import { isEqual } from 'lodash-es';
import { create } from 'zustand';

import { IEvBreadcrumb } from '../components/ev-breadcrumbs/EvBreadcrumbs';

interface BreadcrumbState {
	breadcrumbRoutes: IEvBreadcrumb[];
	setBreadcrumbRoutes: (routes: IEvBreadcrumb[]) => void;
	updateBreadcrumbRoutes: (newRoutes?: IEvBreadcrumb[]) => void;
}

export const useBreadcrumbStore = create<BreadcrumbState>((set, get) => ({
	breadcrumbRoutes: [],
	setBreadcrumbRoutes: (routes: IEvBreadcrumb[]) => set({ breadcrumbRoutes: routes }),
	updateBreadcrumbRoutes: (newRoutes?: IEvBreadcrumb[]) => {
		const currentRoutes = get().breadcrumbRoutes;

		if (newRoutes?.length && !isEqual(currentRoutes, newRoutes)) {
			set({ breadcrumbRoutes: newRoutes });
		} else if (!newRoutes?.length && currentRoutes.length) {
			set({ breadcrumbRoutes: [] });
		}
	}
}));
